export default __webpack_public_path__ + "4fd7ecc4559ca59498324c859620065f.png";